// import Swiper JS
import Swiper, { Navigation, Thumbs, EffectFade} from 'swiper';

Swiper.use([Navigation, Thumbs, EffectFade]);

document.addEventListener("DOMContentLoaded", function() {
  let swiperBlogText = new Swiper(".blogSwiperText", {
    effect: "fade",
  });

  let swiperBlog = new Swiper(".blogSwiper", {
    effect: "fade",
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper : swiperBlogText
    }
  });
});